export function getJsonObject(label: string | undefined): object | undefined {
  // Basic json sanity paas before parse check
  if (
    label === undefined ||
    label.length < 2 || // a valid Json string should have at least two chars '{}'
    (label[0] !== '{' && label[0] !== '[') ||
    (label[label.length - 1] !== '}' && label[label.length - 1] !== ']')
  ) {
    return undefined;
  }

  try {
    return JSON.parse(label);
  } catch (e) {
    return undefined;
  }
}
